var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 346,
    viewBox: "0 0 290 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.81 40.0137C121.81 40.0137 63.0689 72.7457 78.2318 313.449H218.452C218.452 313.449 227.928 107.41 167.292 40.0137H121.81Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.136 313.135V328.327H102.916V340.344H90.5442V346H206.161V339.285H192.635V329.564H186.667V313.135H108.136Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.428 212.23C171.947 212.23 192.635 191.543 192.635 166.023C192.635 140.504 171.947 119.816 146.428 119.816C120.908 119.816 100.221 140.504 100.221 166.023C100.221 191.543 120.908 212.23 146.428 212.23Z",
    fill: "url(#paint0_linear_55_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.813 194.582C162.032 194.582 174.37 182.245 174.37 167.026C174.37 151.806 162.032 139.469 146.813 139.469C131.594 139.469 119.256 151.806 119.256 167.026C119.256 182.245 131.594 194.582 146.813 194.582Z",
    fill: "url(#paint1_linear_55_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7089 292.043H15.1368C13.2971 292.048 11.4783 291.654 9.80624 290.887C8.13414 290.12 6.64867 288.999 5.45265 287.601C0.270013 281.5 -5.44569 269.706 10.1614 256.053C33.0094 236.063 83.281 212.23 83.281 212.23L86.7089 292.043Z",
    fill: "url(#paint2_linear_55_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.161 286.694H275.216C277.005 286.691 278.772 286.292 280.388 285.523C282.003 284.755 283.428 283.638 284.56 282.252C289.565 276.151 295.073 264.357 280.014 250.704C257.965 230.714 209.463 206.889 209.463 206.889L206.161 286.694Z",
    fill: "url(#paint3_linear_55_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.404 254.771H145.836C142.172 254.771 139.202 257.742 139.202 261.405V322.657C139.202 326.32 142.172 329.29 145.836 329.29H150.404C154.068 329.29 157.038 326.32 157.038 322.657V261.405C157.038 257.742 154.068 254.771 150.404 254.771Z",
    fill: "url(#paint4_linear_55_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.875 53.8322H176.132C176.375 53.8217 176.612 53.7474 176.818 53.6168C177.023 53.4862 177.191 53.3038 177.305 53.0879C177.418 52.872 177.472 52.6301 177.463 52.3865C177.453 52.1429 177.38 51.9062 177.25 51.6999L146.191 0.61392C146.082 0.418677 145.924 0.255069 145.732 0.139029C145.541 0.0229886 145.323 -0.0415358 145.099 -0.0482454C144.876 -0.0549551 144.654 -0.00362043 144.456 0.100743C144.258 0.205106 144.091 0.358938 143.97 0.547278L108.772 51.6332C108.626 51.8393 108.538 52.0815 108.518 52.3337C108.499 52.5859 108.549 52.8386 108.662 53.0647C108.775 53.2909 108.948 53.4818 109.162 53.617C109.376 53.7522 109.622 53.8266 109.875 53.8322V53.8322Z",
    fill: "url(#paint5_linear_55_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.321 163.977C168.321 163.977 172.763 176.03 152.21 188.409L168.321 163.977Z",
    fill: "url(#paint6_linear_55_17)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_17",
    x1: 100.228,
    y1: 166.023,
    x2: 192.635,
    y2: 166.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27D49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#788198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_17",
    x1: 8995.85,
    y1: 12572.5,
    x2: 13099.1,
    y2: 12572.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55_17",
    x1: 13029.7,
    y1: 41762.7,
    x2: 23183.4,
    y2: 41762.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27D49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A5BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55_17",
    x1: 14612.8,
    y1: 41177.3,
    x2: 5123.94,
    y2: 41177.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27D49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_55_17",
    x1: 3922.15,
    y1: 29647.3,
    x2: 3492.49,
    y2: 29647.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998958,
    stopColor: "#2AC997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_55_17",
    x1: 20578.9,
    y1: 11660.3,
    x2: 26996.1,
    y2: 11660.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27D49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A5BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_55_17",
    x1: 182.168,
    y1: 170.424,
    x2: 145.417,
    y2: 180.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 289.828,
    height: 346,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket1);
export default __webpack_public_path__ + "static/media/rocket 1.018ae9a5c6039211a20cd15b97eb59b1.svg";
export { ForwardRef as ReactComponent };